export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  hero: "landing-hero",
  startCta: "landing-start-cta",
  disclaimer: "landing-disclaimer",
  featureCard: (i) => `landing-feature-${i}`,
};

export const WIZARD = {
  root: "wizard-root",
  progress: "wizard-progress",
  stepLabel: "wizard-step-label",
  nextBtn: "wizard-next-btn",
  backBtn: "wizard-back-btn",
  submitBtn: "wizard-submit-btn",
  field: (name) => `wizard-field-${name}`,
  checkbox: (group, value) => `wizard-checkbox-${group}-${value}`,
  proposalType: (value) => `wizard-proposal-type-${value}`,
};

export const OUTPUT = {
  root: "output-root",
  editor: "output-editor",
  copyBtn: "output-copy-btn",
  downloadDocxBtn: "output-download-docx-btn",
  downloadPdfBtn: "output-download-pdf-btn",
  regenerateBtn: "output-regenerate-btn",
  professionalBtn: "output-professional-btn",
  warmBtn: "output-warm-btn",
  shortenBtn: "output-shorten-btn",
  expandBtn: "output-expand-btn",
  emailBtn: "output-email-btn",
  startOverBtn: "output-start-over-btn",
};
